export const audits = {
	title: "Relatório de Auditoria",
	subTitle: "Relatório detalhado de ações realizadas através do dashboard e painel Admin",
	navTitle: "Auditoria",
	filters: {
		employeePlaceholder: "Filtrar por funcionário",
		typePlaceholder: "Filtrar por tipo",
		functionPlaceholder: "Filtrar por função",
	},
	table: {
		columns: {
			date: "Data",
			employee: "Funcionário",
			place: "Estabelecimento",
			organization: "Organização",
			type: "Tipo",
			function: "Função",
			observation: "Observação",
			params: "Parâmetros",
			createdAt: "Criado em",
		},
		viewParams: "Visualizar",
		paramsModalTitle: "Parâmetros",
		exportFilename: "Auditorias",
		exportTitle: "Relatório de Auditorias",
	},
};
